import { Typography } from '@mui/material';
import { GridRow, type GridRowId } from '@mui/x-data-grid';
import type { InvoiceOverview } from '@weft/api-definition';
import React, { useCallback, useMemo, useState } from 'react';
import { NavLink } from 'react-router-dom';
import { VyTable, type VyTableMinimalProps } from '../../../../../components/new-design/table/vy-table/VyTable';
import { INVOICE_OVERVIEW_TABLE_COLUMNS } from './invoice-overview-table-consts/invoice-columns';

type InvoiceOverviewTableProps = VyTableMinimalProps<InvoiceOverview> & {
  onInvoicesSelect: (selectedInvoices: InvoiceOverview[]) => void;
};

export const InvoiceOverviewTable: React.FC<InvoiceOverviewTableProps> = ({ onInvoicesSelect, ...props }) => {
  const [selectedInvoicesIds, setSelectedInvoicesIds] = useState<string[]>([]);

  const handleSelectionChange = useCallback((selectedRowKeys: GridRowId[]) => {
    setSelectedInvoicesIds(selectedRowKeys.map((key) => key.toString()));
    const selectedRowsArr = props.items.filter((invoice) => selectedRowKeys.includes(invoice.id));
    onInvoicesSelect(selectedRowsArr);    
  }, [props.items, onInvoicesSelect, setSelectedInvoicesIds]);

  const rowSelectionModel = useMemo(() => props.loadingItems ? [] : selectedInvoicesIds ?? [], [props.loadingItems, selectedInvoicesIds]);

  return (
    <>
      <VyTable
        columns={INVOICE_OVERVIEW_TABLE_COLUMNS}
        checkboxSelection
        disableRowSelectionOnClick
        onRowSelectionModelChange={(newRowSelectionModel) => handleSelectionChange(newRowSelectionModel)}
        rowSelectionModel={rowSelectionModel}
        disableColumnMenu
        getRowId={(row) => row.id}
        initialState={{
          columns: {
            columnVisibilityModel: {
              customerExternalId: false,
              customerErpId: false,
            },
          },
        }}
        {...props}
        sx={{
          paddingBottom: '150px',
        }}
        slotProps={{
          baseCheckbox: {
            onClick: (event) => event.stopPropagation(),
          },
        }}
        slots={{
          row: (rowProps) => (
            <NavLink
              onClick={(event: React.MouseEvent<HTMLAnchorElement> & { ignore?: boolean }) => {
                if (event.ignore) {
                  event.preventDefault();
                }
              }}
              to={`/invoices/${rowProps.row.id}/customer/${rowProps.row.customer.id}`}
            >
              <GridRow {...rowProps} />
            </NavLink>
          ),
        }}
      />

      <Typography sx={{
        position: 'absolute',
        left: 20,
        bottom: 16,
      }}
      >
        {`Selected invoices: ${selectedInvoicesIds?.length ?? 0}`}
      </Typography>
    </>
  );
};
